import Header from '@/components/MedicalKorUpload/Header';
import styled from 'styled-components';
import { Button, Icon } from '@successmode-ktp/kui';
import UploadFile from '@/components/MedicalKorUpload/UploadFile';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constant/routes.const';
import { useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { IGlobalState } from '@/store';
import { uploadTicket } from '@/api';
import { useState } from 'react';
import { ICON_CAUTION_GRAY } from '@repo/assets';
import UploadedModal from '@/components/MedicalUploadFile/Uploaded.modal';

const MedicalUploadFile = () => {
  const history = useHistory();
  const { passportNumber } = useSelector((state) => state) as IGlobalState;
  const { mutate: mutateUploadTicket } = useMutation(uploadTicket);
  const [files, setFiles] = useState<File[]>([]);
  const [isUpload, setIsUpload] = useState(false);
  const isCruise =
    passportNumber && localStorage.getItem(passportNumber) === 'Cruise';

  const onSaveTicket = async () => {
    if (passportNumber && files.length !== 0) {
      const passportNumberBlob = new Blob(
        [JSON.stringify({ passportNumber })],
        {
          type: 'application/json',
        },
      );
      const ticketUploadData = new FormData();
      // const resizedFilesPromise = files.map(async (file) => {
      //   return await resizeFile(file);
      // });
      // const resizedfile = await Promise.all(resizedFilesPromise);
      ticketUploadData.append('request', passportNumberBlob);
      files.forEach((file: File) => {
        ticketUploadData.append('file', file);
      });

      mutateUploadTicket(ticketUploadData, {
        onSuccess: () => {
          setIsUpload(true);
        },
        onError: () => {
          setIsUpload(false);
        },
      });
    }
  };

  return (
    <Wrapper>
      <Header title='Upload documents' />
      <Container>
        <Title>
          {isCruise
            ? 'Upload your Cruise ticket and the travel itinerary'
            : 'Upload your entry & departure flight tickets'}
        </Title>
        {isCruise && (
          <GuideText>
            Travel Itinerary (must issued by official travel agency)
          </GuideText>
        )}
        <UploadFile onChange={(v) => setFiles(v)} nationality='ENG' isGuide />
        <GuideBox>
          <GuideHeader>
            <WarningIcon>
              <img src={ICON_CAUTION_GRAY} alt='' width={24} height={24} />
            </WarningIcon>
            <GuideMainText>
              Take a photo of the ticket showing all the details
            </GuideMainText>
          </GuideHeader>
          <GuideList>
            <GuideItem>
              <CheckIcon>✓</CheckIcon>
              <GuideItemText>Passenger Name</GuideItemText>
            </GuideItem>
            <GuideItem>
              <CheckIcon>✓</CheckIcon>
              <GuideItemText>Flight No, Date</GuideItemText>
            </GuideItem>
            <GuideItem>
              <CheckIcon>✓</CheckIcon>
              <GuideItemText>From, To</GuideItemText>
            </GuideItem>
            <GuideItem>
              <CheckIcon>✓</CheckIcon>
              <GuideItemText>Entry Ticket, Departure Ticket</GuideItemText>
            </GuideItem>
          </GuideList>
        </GuideBox>
        <CautionText>
          *Both paper tickets and E-ticket screenshots are accepted.
        </CautionText>
        <ButtonWrapper>
          <Button
            type='button'
            size='lg'
            onClick={onSaveTicket}
            disabled={files.length === 0}
          >
            submit
          </Button>
        </ButtonWrapper>
      </Container>
      <UploadedModal
        isOpen={isUpload}
        onClose={() => {
          setIsUpload(false);
          history.push(routes.medicalHome);
        }}
      />
    </Wrapper>
  );
};
export default MedicalUploadFile;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
`;

const Container = styled.div`
  width: 375px;
  padding: 110px 20px 0;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;

const Title = styled.p`
  padding: 20px 0 0;
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 24px;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
  letter-spacing: -0.48px;
`;

const GuideText = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 13px;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 56px;
`;

const GuideBox = styled.div`
  width: 100%;
  background-color: #f5f6f7;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

const GuideHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

const WarningIcon = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6165;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
`;

const GuideMainText = styled.p`
  flex: 1;
  color: #777777;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.24px;
  margin: 0;
`;

const GuideList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-left: 22px;
  width: 100%;
`;

const GuideItem = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
`;

const CheckIcon = styled.div`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
`;

const GuideItemText = styled.p`
  color: #666666;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: -0.24px;
  margin: 0;
`;

const CautionText = styled.small`
  display: block;
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 12px;
  font-weight: 400;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;
  margin-top: 6px;
`;
